import * as angular from "angular";
import {IController} from "angular";
import {ContentTemplateModel} from "../../models/content-template.model";

export class ContentTemplatesTableComponent implements IController {

  infiniteScroll: any;
  onEdit: Function;
  onDelete: Function;
  constructor() {
  }

}

angular
  .module('bringoz.admin.content-templates')
  .component('contentTemplatesTable', {
    bindings: {
      infiniteScroll: '<',
      onEdit: '&',
      onDelete: '&'
    },
    template: require('./content-templates-table.html').default,
    controller: ContentTemplatesTableComponent
  });
